import * as moment from "moment-timezone";
import { EditorialMessageContent } from "./EditorialMessageContent";

export interface SignalMessage {
  id: string;
  dateUtc: moment.Moment;
  content: EditorialMessageContent | any;
}

export interface SignalMessagePage {
  items: SignalMessage[];
  pageNumber: number;
  pageSize: number;
  total: number;
}

export enum SignalMessageActionType {
  CREATE = "create",
  EDIT = "edit",
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/SignalMessage.ts